// TODO(i18n): This is a temporary frontend fallback for plan copy.
// The preferred approach is for GET /plan_details/ to accept a locale (for example,
// an Accept-Language header) and return localized descriptions and features. Once
// the backend supports that contract, use its text as the primary source and keep
// this catalog only as a fallback when localized API data is unavailable.
export function localizePlan(plan, t, tm) {
  const localizedCopy = tm(`plans.catalog.${plan.title}`)
  const hasLocalizedCopy = localizedCopy && typeof localizedCopy === 'object'

  // Until the backend provides localized copy, the frontend catalog is primary.
  return {
    ...plan,
    ...(hasLocalizedCopy ? localizedCopy : {}),
    priceMonthly:
      plan.priceMonthly === 'Free' ? t('plans.free') :
        plan.priceMonthly === 'Individual Terms' ? t('plans.individualTerms') : plan.priceMonthly,
    priceAnnual:
      plan.priceAnnual === 'Free' ? t('plans.free') :
        plan.priceAnnual === 'Individual Terms' ? t('plans.individualTerms') : plan.priceAnnual,
  }
}
